var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnsBrunchLineWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Common/icon/sns_brunch_line_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TA_footer_OPEN",
    transform: "translate(-172, -386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/icon/sns_brunch_line_white",
    transform: "translate(172, 386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "evenodd",
    transform: "translate(8, 10)",
    fill: "#ECE0CE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0427122,9.68739417 C11.9488689,9.83531424 11.7977126,9.94125155 11.6225781,9.98184348 C11.4474436,10.0224354 11.2627165,9.99434772 11.1091351,9.90377468 C8.55259013,8.40161862 5.33421958,8.06141342 1.54400054,8.89441586 C1.17854757,8.97435694 0.814873318,8.75434772 0.7314764,8.40286938 C0.691188833,8.23407475 0.722367512,8.05679693 0.818134336,7.91014388 C0.91390116,7.76349083 1.06638706,7.65951289 1.24195324,7.62114786 C5.38974011,6.70959804 8.94760507,7.10208478 11.8177696,8.78935249 C12.1376302,8.97821641 12.2390495,9.37970858 12.0427122,9.68739417 L12.0427122,9.68739417 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4494343,6.74477218 C13.2107839,7.13697724 12.7031785,7.26081803 12.3155295,7.01951999 C9.47319147,5.25306516 5.1404884,4.74148778 1.77854922,5.77332415 C1.34253886,5.90648492 0.882032108,5.65803731 0.749701131,5.21795565 C0.618229877,4.77743413 0.864140706,4.31242079 1.29948078,4.17833136 C5.13973078,3.00018412 9.91387383,3.57087313 13.1779537,5.59892568 C13.5656027,5.84022371 13.6880846,6.35346081 13.4494343,6.74489985 L13.4494343,6.74477218 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5112089,4.13392486 C10.1156789,1.92049915 4.51349481,1.71698162 1.27157516,2.79683955 C0.750985941,2.9701194 0.200454667,2.64758416 0.0426927341,2.07624391 C-0.115274082,1.50464879 0.178765027,0.900713969 0.699530893,0.72714637 C4.42102669,-0.512736538 10.6075841,-0.273182324 14.5169097,2.27382436 C14.7419333,2.419919 14.9047429,2.65827402 14.9694136,2.93629507 C15.0340843,3.21431612 14.9953007,3.50915243 14.8616208,3.75574677 C14.5848455,4.26964924 13.9784559,4.43906308 13.5117121,4.13392486 L13.5112089,4.13392486 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#ECE0CE",
    cx: 15,
    cy: 15,
    r: 11.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsBrunchLineWhite);
export default __webpack_public_path__ + "static/media/sns_brunch_line_white.9857f5929873aa83fa075de982f7d699.svg";
export { ForwardRef as ReactComponent };